// ©2024 Austin App House. All rights reserved.
import React from 'react';
import {
    MDBCol, MDBRow, MDBTable, MDBTableBody,
} from 'mdbreact';
import ApplyRow from './ApplyRow';

const PreviousApplicantsHistory = ({
                                       applicants,
                                       inviteContractor,
                                       currentWorkOrder,
                                       blockedContractors,
                                       showContractorProfile,
                                   }) => (
    applicants && applicants.length ? (
        <MDBRow style={{ marginBottom: '0px' }}>
            <MDBCol>
                <h3 style={{ fontWeight: 'bold' }}>Previous Applicants</h3>
                <div>
                    <MDBRow style={{ marginBottom: '15px' }} />
                    <MDBRow>
                        <MDBCol>
                            <MDBTable className="applicantappiliedwo_table">
                                <MDBTableBody>
                                    {applicants.map((applyInfo) => (
                                        <ApplyRow
                                            key={applyInfo._id}
                                            applyInfo={applyInfo}
                                            invite={() =>
                                                inviteContractor({
                                                    workOrdersId: [currentWorkOrder._id],
                                                    contractorId: applyInfo.contractor_id,
                                                })
                                            }
                                            baseType={currentWorkOrder.basicType}
                                            variableType={currentWorkOrder.variableType}
                                            blocked={blockedContractors.some(
                                                (id) => id === applyInfo.contractor_id
                                            )}
                                            showContractorProfile={showContractorProfile}
                                        />
                                    ))}
                                </MDBTableBody>
                            </MDBTable>
                        </MDBCol>
                    </MDBRow>
                </div>
            </MDBCol>
        </MDBRow>
    ) : null
);

export default PreviousApplicantsHistory;
